<template>
    <div>
<v-dialog
      v-model="dialog"
      width="500"
    >
    
      <template v-slot:activator="{ on, attrs }">
        
        <v-btn v-bind="attrs" v-on="on" 
        color="blue" class="white--text"> 
        Ajustar horário
        </v-btn>

      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">
          Ajustar horário
        </v-card-title>

        <div >
           <v-form class="pa-5" ref="form">
            <v-text-field prepend-icon="mdi-clock-alert" label="Horário inicial" type="time" v-model="horaInit" >

            </v-text-field>
            <v-text-field prepend-icon="mdi-clock-alert" label="Horário final" type="time" v-model="horaFim" >

            </v-text-field>


           </v-form>
        </div>

        <v-divider></v-divider>
      
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn  color="primary" text @click="dialog = false">
            Fechar
          </v-btn>
          <v-btn  color="primary" text @click="atualizarItem">
            Atualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>

import {refAgenda} from '@/firebaseConfig'

    export default {
        props: ['itemPassado'],
        data(){
            return {
                dialog: false,
                horaInit: '',
                horaFim: '',
            }
        },
        created(){
        this.metodoInit()
        },
        methods: {
            metodoInit(){
                console.log(this.itemPassado);
                this.horaInit = this.itemPassado.start.split(" ")[1]
                this.horaFim = this.itemPassado.end.split(" ")[1]
                console.log(this.horaInit);
                console.log(this.horaFim);
            },
            atualizarItem(){
                let startF = this.itemPassado.start.split(" ")[0] + "T"+ this.horaInit.toString()
                let endF = this.itemPassado.end.split(" ")[0] + "T"+ this.horaFim.toString()
                refAgenda.doc(this.itemPassado.id).update({ start: startF, end: endF}).then(()=>{
                    this.$emit('attAgenda');
                    this.dialog = false
                });
            }
        }

    }
</script>

<style lang="scss" scoped>

</style>